module.exports = __webpack_public_path__ + "static/media/ha.0512c680.jpg";